import _ from 'lodash';
import { TemperatureUnit } from '../../../system/models/temperatureUnits';
import {
  DayOfWeek,
  EmptyWeeklySchedule,
  MyDailySchedule,
  MyWeeklySchedule,
} from '../residential-devices/thermostat/types';
import { convertLimitTemperature } from './convert-temp-units';

// Formats the current daily schedule with preferred units
export const convertToPreferredDailyScheduleUnits = (
  dailySchedule: MyDailySchedule,
  targetUnit: TemperatureUnit,
  currentUnits: TemperatureUnit,
) => {
  let scheduleUpdate: MyDailySchedule = _.cloneDeep(EmptyWeeklySchedule['0']);

  for (const transition in dailySchedule) {
    const scheduleSetting = dailySchedule[transition];
    scheduleUpdate[transition] = {};
    if (scheduleSetting.maximum !== undefined) {
      scheduleUpdate[transition].maximum = convertLimitTemperature(
        scheduleSetting.maximum,
        targetUnit,
        currentUnits,
      );
    }

    if (scheduleSetting.minimum !== undefined) {
      scheduleUpdate[transition].minimum = convertLimitTemperature(
        scheduleSetting.minimum,
        targetUnit,
        currentUnits,
      );
    }
  }

  return scheduleUpdate;
};

// Formats the current weekly schedule with preferred units
export const convertToPreferredWeeklyScheduleUnits = (
  schedule: MyWeeklySchedule,
  targetUnit: TemperatureUnit,
  currentUnits: TemperatureUnit,
) => {
  let scheduleUpdate: MyWeeklySchedule = _.cloneDeep(EmptyWeeklySchedule);
  if (schedule) {
    for (const day in schedule) {
      const dailySchedule = schedule[day as DayOfWeek];
      scheduleUpdate[day as DayOfWeek] = convertToPreferredDailyScheduleUnits(
        dailySchedule,
        targetUnit,
        currentUnits,
      );
    }
  }
  return scheduleUpdate;
};

export const convertDailyScheduleToCelciusUnits = (
  dailySchedule: MyDailySchedule,
) => {
  let scheduleUpdate: MyDailySchedule = _.cloneDeep(EmptyWeeklySchedule['0']);

  for (const transition in dailySchedule) {
    const scheduleSetting = dailySchedule[transition];
    scheduleUpdate[transition] = {};
    if (scheduleSetting.maximum !== undefined) {
      scheduleUpdate[transition].maximum = convertLimitTemperature(
        scheduleSetting.maximum,
        'C',
        'F',
      );
    }

    if (scheduleSetting.minimum !== undefined) {
      scheduleUpdate[transition].minimum = convertLimitTemperature(
        scheduleSetting.minimum,
        'C',
        'F',
      );
    }
  }

  return scheduleUpdate;
};

export const convertWeeklyScheduleToCelciusUnits = (
  schedule: MyWeeklySchedule,
) => {
  let scheduleUpdate: MyWeeklySchedule = _.cloneDeep(EmptyWeeklySchedule);
  if (schedule) {
    for (const day in schedule) {
      const dailySchedule = schedule[day as DayOfWeek];
      scheduleUpdate[day as DayOfWeek] =
        convertDailyScheduleToCelciusUnits(dailySchedule);
    }
  }
  return scheduleUpdate;
};
